var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreatIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23448 2.68022V4.79558H2.90758H0.580688V19.18V33.5645H19.1958H37.811V31.4491V29.3337H40.1379H42.4648V14.9493V0.564865H23.8496H5.23448V2.68022ZM40.7725 14.9493V27.6414H39.2917H37.811V16.2185V4.79558H22.3689H6.92676V3.52637V2.25715H23.8496H40.7725V14.9493ZM36.1187 19.18V31.8722H19.1958H2.27297V19.18V6.48787H19.1958H36.1187V19.18Z",
    fill: "#FF5B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63438 13.4686C8.44978 13.9763 7.34979 15.584 7.34979 16.8532C7.34979 17.1493 7.85748 17.9955 8.44978 18.7147C9.97284 20.5339 11.919 20.5339 13.442 18.7147C14.7112 17.2339 14.7959 16.6416 13.9074 14.9917C13.1036 13.384 11.2844 12.7494 9.63438 13.4686ZM12.9343 15.584C13.5689 16.9378 12.4267 18.757 10.9459 18.757C9.04208 18.757 8.11132 15.9224 9.63438 14.8647C10.6921 14.1455 12.4267 14.5263 12.9343 15.584Z",
    fill: "#FF5B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8881 17.4878C20.8881 18.2917 21.1842 18.334 26.8111 18.334C32.4379 18.334 32.7341 18.2917 32.7341 17.4878C32.7341 16.684 32.4379 16.6417 26.8111 16.6417C21.1842 16.6417 20.8881 16.684 20.8881 17.4878Z",
    fill: "#FF5B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57668 21.0837C7.22285 21.8029 6.29209 23.199 5.91133 25.0182C5.61518 26.2028 5.69979 26.3721 6.46132 26.3721C7.13824 26.3721 7.34977 26.1182 7.34977 25.1875C7.39208 22.6913 10.0151 21.2106 12.5536 22.3106C13.7805 22.8183 14.1612 23.2413 14.542 24.6375C14.7958 25.6528 15.2612 26.3721 15.5997 26.3721C17.1227 26.3721 15.5997 22.5221 13.6112 21.2952C12.0036 20.3221 10.142 20.2375 8.57668 21.0837Z",
    fill: "#FF5B37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8881 22.565C20.8881 23.3688 21.1842 23.4111 26.8111 23.4111C32.4379 23.4111 32.7341 23.3688 32.7341 22.565C32.7341 21.7612 32.4379 21.7188 26.8111 21.7188C21.1842 21.7188 20.8881 21.7612 20.8881 22.565Z",
    fill: "#FF5B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatIcon02);
export default __webpack_public_path__ + "static/media/great-icon-02.8bb849f758ef79bdc46d584e6e0553cd.svg";
export { ForwardRef as ReactComponent };